module.exports = __webpack_public_path__ + "img/choose1.54ac81b1.png";